import LoaderWrapper, { LoaderWrapperProps } from './LoaderWrapper'
import LoaderSVG from './LoaderSVG'
import { Loader } from './Loader'
import { LoaderOverlayWrapper } from './LoaderOverlayWrapper'
export default LoaderWrapper
export { LoaderWrapper, LoaderSVG, Loader, LoaderOverlayWrapper }
export type { LoaderWrapperProps }
